export default __webpack_public_path__ + "src/static/img/webp/logo-white.webp";